<mat-dialog-content>


  <div [formGroup]="form">

    <fieldset>
      <label>{{'front.organisme-gestionnaire.type-organisme'| translate}} <span class="star">*</span> : </label>
      <mat-select class="form-control" placeholder="{{'front.organisme-gestionnaire.type-organisme'| translate}}" formControlName="type">
        @for (typeOrganisme of data.typeOrganismes; track typeOrganisme) {
          <mat-option [value]="typeOrganisme">
            {{typeOrganisme}}
          </mat-option>
        }
      </mat-select>
    </fieldset><br>

    <fieldset class="form-group">
      <label >{{'front.organisme-gestionnaire.colonnes.libelle' | translate}} <span class="star">*</span> :</label>
      <input class="form-control" placeholder="{{'front.organisme-gestionnaire.colonnes.libelle' | translate}}" formControlName="libelle">
    </fieldset>

    <fieldset class="form-group">
      <label>{{'fields.titre.acronym.label' | translate}} <span class="star">*</span> :</label>
      <input class="form-control" placeholder="{{'fields.titre.acronym.label' | translate}}" formControlName="acronyme">
    </fieldset>

    <fieldset class="form-group">
      <label>{{'general.ville' | translate}} <span class="star">*</span> :</label>
      <input class="form-control" placeholder="{{'general.ville' | translate}}" formControlName="ville">
    </fieldset>





  </div>

</mat-dialog-content>
<mat-dialog-actions >

  <button mat-button color="warn" [mat-dialog-close]="false">{{'general.annuler' | translate}}</button>
  <button mat-raised-button color="primary" [disabled]="form.invalid" [mat-dialog-close]="form.value">{{ 'general.save' | translate}}</button>
</mat-dialog-actions>
